import React from 'react'
import styled from 'styled-components'
import { CurrencyValue } from '../../../model'
import { getStakingParams } from '../../../pages/token/staking/utils'
import { StakingClaimInfo } from '../../../providers/transactions/model'
import { Parameter, Parameters } from './Parameters'
import { SingleItem } from './SingleItem'

interface Props {
  now: Date
  submittedAt: number
  txInfo: StakingClaimInfo
  symbol: string
  claimedAmount?: CurrencyValue
}

export function SingleStakingClaimItem({ now, submittedAt, txInfo, symbol, claimedAmount }: Props) {
  const { stakingOption, value } = txInfo
  const { duration } = getStakingParams(stakingOption)
  const displayValue = `${claimedAmount ? claimedAmount.format() : value} ${symbol}`
  return (
    <Container>
      <SingleItem description={`Staking Claim ${symbol}`} now={now} submittedAt={submittedAt} symbol0={symbol} />
      <Parameters>
        <Parameter text={`${claimedAmount ? '' : 'Estimated '}${duration}`} value={displayValue} />
      </Parameters>
    </Container>
  )
}

const Container = styled.div``
